import { Save } from '@mui/icons-material';
import { Box, Card, Divider } from '@mui/material';
import './scss/restaurant-extensions.scss';
import i18n from '../../../i18n';
import DialogComponent from '../../../component/dialog/dialog.component';
import ButtonComponent from '../../../component/button/button.component';
import CommonInput from '../../../component/form/common-input.component';
import React from 'react';
import { SecretKey } from '../../../models';
import moment from 'moment';
import { CheckRule } from '../../../constants/regular.constant';

/**
 * 餐厅拓展功能-密钥
 */
export default function RestaurantExtensionsDialog(props: {
    open: boolean;
    onClose: () => void;
    secretKey: SecretKey;
    onSave: (params: { name: string }) => Promise<void>;
    dialogType: 'ADD' | 'EDIT';
}) {
    const [name, setName] = React.useState('');
    React.useEffect(() => {
        if (props.open) {
            setName(props?.secretKey?.name || '');
        }
    }, [props.open, props.secretKey])

    const data = [
        { label: i18n.t('restaurant_extensions_page_text_key'), value: props?.secretKey?.value },
        {

            label: i18n.t('restaurant_extensions_page_text_create_time'),
            value: props?.secretKey?.creation_time ? moment(props?.secretKey?.creation_time, moment.HTML5_FMT.DATETIME_LOCAL_MS).format('HH:mm:ss DD/MM/YYYY') : ''
        }
    ];

    return (
        <DialogComponent
            open={props.open}
            maxWidth={'xs'}
            sx={{ '& .MuiDialog-paper': { minWidth: '40%', } }}
            fullWidth={false}
            onClose={() => {
                props.onClose();
            }}
            defaultHeaderProps={
                {
                    title: i18n.t('restaurant_extensions_page_text_key'),
                    rightNode: (
                        <ButtonComponent
                            variant='outlined'
                            handleClick={async () => {
                                if (CheckRule('emptyName', name)) {
                                    await props.onSave({ name });
                                }
                            }}
                            titleText={i18n.t('general_text_save')}
                        >
                            <Save className='iconColor' />
                        </ButtonComponent>
                    )
                }
            }
        >
            <CommonInput
                style={{ marginTop: '0.5rem' }}
                required
                regularType='emptyName'
                label={i18n.t('responsible_person_info_component_text_name')}
                value={name}
                onChange={(e) => { setName(e.target.value || '') }}
                fullWidth
            />
            {props.dialogType === 'EDIT' &&
                <Card style={{ margin: '1rem 0' }}>
                    <Box>
                        {data.map((item, index) => {
                            return (
                                <Box key={item.label + index}>
                                    <Box display={'flex'} alignItems={'center'} justifyContent={'space-between'} padding={'0.85rem'}>
                                        <Box component='p' sx={(theme) => { return { wordBreak: 'keep-all', marginRight: '0.5rem', color: theme.palette.text.secondary } }} >
                                            {item.label}:
                                        </Box>
                                        <Box component='p' sx={(theme) => { return { wordBreak: 'break-all', color: theme.palette.text.secondary } }} >
                                            {item.value}
                                        </Box>
                                    </Box>
                                    <Divider />
                                </Box>
                            )
                        })}
                    </Box>
                </Card>}
        </DialogComponent >
    )
}